export default {
  ADDRESS_UPDATED: 'location:address-updated',
  SET_COORDINATES: 'location:set-coordinates',
  SHOW_FORM_ERRORS: 'location:show-form-errors',
  SET_ADDRESS_DETAILS: 'location:set-address-details',
  RUN_ADDRESS_EMBED: 'location:run-address-embed',
  RENDER_LOCATION_DATA: 'location:render-location-data',
  RUN_ADDRESS_BLOCKING_EMBED: 'location:run-address-blocking-embed',
  SET_LOCATION_DETAILS: 'location:set-location-details',
  SHOW_BLOCKING_MODAL: 'location:show-blocking-modal',
  SHOW_REMOVE_PAYCENTRE_BLOCKING_MODAL:
    'location:show-remove-paycentre-blocking-modal',
  UPDATE_ADDRESS_DETAILS: 'location:set-archived-address-details',
  ADDRESS_UPDATE_CONCLUDED: 'location:address-update-concluded',
  RUN_VERIFY_ADDRESS_BANNER_EMBED: 'location:run-verify-address-banner-embed',
  RUN_FILTER_LOCATIONS_LIST_EMBED: 'location:run-filter-locations-list-embed',
  LOCATIONS_LIST_UPDATED: 'location:locations-list-updated',
  RUN_LOCATION_ADVANCED_SETTINGS_EMBED:
    'location:run-location-advanced-settings-embed',
  RUN_REMOVE_PAYCENTRE_EMBED: 'location:run-remove-paycentre-embed',
  IS_ADVANCED_SETTINGS_UPDATED: 'location:advanced-settings-updated',
  SET_ADVANCED_SETTINGS: 'location:set-advanced-settings',
  UPDATE_LOCATION_DETAILS: 'location:update-location-details',
  SET_PAYCENTRE_CONFIG: 'location:set-paycentre-config',
};
